<template>
    <div class="status-container" :class="statusClass">
        <span>
            {{ status }}
        </span>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import i18n from '@/plugins/i18n';

export function statusName(status: string): string {
    return i18n.global.t(`state.${status}`);
}

export default defineComponent({
    name: 'StatusTag',
    props: { status: { type: String, required: true } },
    computed: {
        statusClass() {
            switch (this.$props.status) {
                case this.$t('state.EN_ATTENTE'):
                case this.$t('state.PLANNED'):
                    return 'planifie';
                case this.$t('state.A_QUALIFIER'):
                case this.$t('state.COMMANDE_TRANSMISE'):
                    return 'sable';
                case this.$t('state.REALISE'):
                case this.$t('state.TRAITEE'):
                case this.$t('state.CLOTUREE'):
                    return 'fait';
                case this.$t('state.EN_TRAITEMENT'):
                    return 'en-commande';
                case this.$t('state.ENCOURS'):
                case this.$t('state.EN_CHIFFRAGE'):
                    return 'en-cours';
                case this.$t('state.A_TRAITER'):
                    return 'non-planifie';
                case this.$t('state.PUBLIE'):
                    return 'publie ';
                case this.$t('state.UNPLANNED'):
                    return 'non-planifie';
                case this.$t('state.A_REALISER'):
                    return 'a-faire';
                case this.$t('state.REFUSE'):
                case this.$t('state.REFUSEE'):
                    return 'rouge';
                case this.$t('state.ENCOMMANDE'):
                    return 'en-commande';
                case this.$t('state.EN_SIGNATURE'):
                    return 'a-faire';
                default:
                    return '';
            }
        },
    },
});
</script>

<style scoped>
.status-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 115px;
    height: 24px;
    border-radius: 12px;
    font-size: var(--font-size-very-small);
}
.a-faire {
    background-color: var(--a-faire);
    color: white;
}
.sable {
    background-color: var(--etat-jaune);
    color: white;
}
.fait {
    background-color: var(--fait);
    color: white;
}
.bleu {
    background-color: var(--etat-bleu);
    color: white;
}
.en-cours {
    background-color: var(--en-cours);
    color: white;
}
.violet {
    background-color: var(--etat-violet);
    color: white;
}
.rouge {
    background: var(--etat-rouge);
    color: white;
}
.non-planifie {
    color: white;
    background-color: var(--non-planifie);
}
.planifie {
    color: white;
    background-color: var(--planifie);
}
.publie {
    color: white;
    background-color: var(--planifie);
}
.en-commande {
    color: white;
    background-color: var(--en-commande);
}
.refuse {
    color: white;
    background-color: var(--non-planifie);
}
.a-qualifier {
    color: white;
    background-color: var(--a-qualifier);
}
</style>
